console.log("[Necheli] preorder ack script loaded");

(function () {
  const MODAL_ID = "PreorderAckModal";
  const ACK_FLAG = "__necheli_preorder_ack_in_progress";

  let confirming = false;

  function qs(sel, root = document) {
    return root.querySelector(sel);
  }

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function isDrawerMode() {
    try {
      return String(window.theme?.settings?.cartType || "").toLowerCase() === "drawer";
    } catch (e) {
      return false;
    }
  }

  function openModal(message) {
    const modal = getModal();
    if (!modal) return;

    const text = qs("#PreorderAckText", modal);

    if (text) {
      text.textContent = message;
    }

    modal.hidden = false;

    const confirmBtn = qs("[data-preorder-confirm]", modal);

    if (confirmBtn) {
      confirmBtn.focus();
    }
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;

    modal.hidden = true;
  }

  function isPreorderButton(btn) {
    if (!btn) return false;

    const value = String(
      btn.getAttribute("data-necheli-preorder") || ""
    ).toLowerCase();

    return value === "true" || value === "1";
  }

  function getButtonMeta(btn) {
    return {
      dispatch: String(
        btn.getAttribute("data-necheli-dispatch-timeline") || ""
      ).trim()
    };
  }

  function buildMessage(meta) {
    const parts = [];

    parts.push("This item is available for preorder.");

    if (meta.dispatch) {
      parts.push(`Estimated dispatch within ${meta.dispatch}.`);
    } else {
      parts.push("Estimated dispatch within 6-8 weeks.");
    }

    parts.push(
      "By proceeding, you acknowledge that this is a preorder item."
    );

    return parts.join(" ");
  }

  function upsertHiddenProperty(form, key, value) {
    if (!form) return;

    const name = `properties[${key}]`;

    let el;

    try {
      el = form.querySelector(
        `input[name="${CSS.escape(name)}"]`
      );
    } catch (e) {
      el = form.querySelector(
        `input[name="${name.replace(/"/g, '\\"')}"]`
      );
    }

    if (!el) {
      el = document.createElement("input");
      el.type = "hidden";
      el.name = name;
      form.appendChild(el);
    }

    el.value = value;
  }

  function removeHiddenProperty(form, key) {
    if (!form) return;

    const name = `properties[${key}]`;

    let el;

    try {
      el = form.querySelector(
        `input[name="${CSS.escape(name)}"]`
      );
    } catch (e) {
      el = form.querySelector(
        `input[name="${name.replace(/"/g, '\\"')}"]`
      );
    }

    if (el) {
      el.remove();
    }
  }

  function submitFormInThemeWay(form, btn) {
    if (btn && typeof btn.click === "function") {
      btn.click();
      return;
    }

    if (form && typeof form.requestSubmit === "function") {
      form.requestSubmit();
      return;
    }

    if (form) {
      form.submit();
    }
  }

  function openDrawerAfterCartUpdate() {
    if (window.location.pathname === "/cart") return;
    if (!isDrawerMode()) return;

    const opener =
      document.querySelector('[data-drawer-trigger="cart"]') ||
      document.querySelector(".js-drawer-open-cart") ||
      document.querySelector('[aria-controls="CartDrawer"]') ||
      document.querySelector("[data-cart-drawer-open]");

    if (opener) {
      opener.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );

      return;
    }

    const drawer =
      document.querySelector("#CartDrawer") ||
      document.querySelector("[data-cart-drawer]") ||
      document.querySelector(".cart-drawer");

    if (drawer && typeof drawer.open === "function") {
      drawer.open();
    }
  }

  function waitForThemeCartUpdateThenOpenDrawer() {
    if (!isDrawerMode()) return;

    let done = false;

    const finish = () => {
      if (done) return;

      done = true;
      cleanup();

      setTimeout(openDrawerAfterCartUpdate, 60);
    };

    const cleanup = () => {
      document.removeEventListener("cart:updated", finish);
      document.removeEventListener("cart:refresh", finish);
      document.removeEventListener("ajaxProduct:added", finish);
      document.removeEventListener("cart:change", finish);
      document.removeEventListener("cart:afterAdd", finish);
    };

    document.addEventListener("cart:updated", finish, { once: true });
    document.addEventListener("cart:refresh", finish, { once: true });
    document.addEventListener("ajaxProduct:added", finish, { once: true });
    document.addEventListener("cart:change", finish, { once: true });
    document.addEventListener("cart:afterAdd", finish, { once: true });

    setTimeout(() => {
      if (!done) finish();
    }, 1400);
  }

  function attach() {
    const modal = getModal();

    if (!modal) {
      console.warn("[Necheli] Preorder acknowledgment modal not found");
      return;
    }

    let pending = null;

    modal.addEventListener("click", (e) => {
      const t = e.target;

      if (
        t.matches("[data-preorder-close]") ||
        t.matches("[data-preorder-cancel]")
      ) {
        e.preventDefault();
        e.stopPropagation();

        if (typeof e.stopImmediatePropagation === "function") {
          e.stopImmediatePropagation();
        }

        pending = null;
        confirming = false;

        closeModal();
        return;
      }

      if (t.matches("[data-preorder-confirm]")) {
        e.preventDefault();
        e.stopPropagation();

        if (typeof e.stopImmediatePropagation === "function") {
          e.stopImmediatePropagation();
        }

        const job = pending;

        pending = null;

        closeModal();

        if (!job) return;

        if (confirming) return;

        confirming = true;

        job.form[ACK_FLAG] = true;

        /*
         * These become Shopify line-item properties.
         * They provide a record that the customer acknowledged
         * the preorder before adding the item.
         */
        upsertHiddenProperty(job.form, "Preorder", "Yes");

        upsertHiddenProperty(
          job.form,
          "Dispatch timeline",
          job.meta.dispatch || "6-8 weeks"
        );

        upsertHiddenProperty(
          job.form,
          "Preorder acknowledged",
          "Yes"
        );

        if (isDrawerMode()) {
          waitForThemeCartUpdateThenOpenDrawer();
        }

        submitFormInThemeWay(job.form, job.btn);

        setTimeout(() => {
          try {
            job.form[ACK_FLAG] = false;
          } catch (_) {}

          confirming = false;

          removeHiddenProperty(job.form, "Preorder");
          removeHiddenProperty(job.form, "Dispatch timeline");
          removeHiddenProperty(job.form, "Preorder acknowledged");
        }, 2000);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;

      const modal = getModal();

      if (modal && !modal.hidden) {
        pending = null;
        confirming = false;
        closeModal();
      }
    });

    document.addEventListener(
      "click",
      (e) => {
        const btn =
          e.target.closest("[data-add-to-cart]") ||
          e.target.closest('button[name="add"]') ||
          e.target.closest('button[type="submit"]');

        if (!btn) return;
        if (!isPreorderButton(btn)) return;

        const form = btn.closest('form[action^="/cart/add"]');

        if (!form) return;

        /*
         * Confirmation just occurred.
         * Allow Impulse to process this click normally.
         */
        if (form[ACK_FLAG]) return;

        e.preventDefault();
        e.stopPropagation();

        if (typeof e.stopImmediatePropagation === "function") {
          e.stopImmediatePropagation();
        }

        const meta = getButtonMeta(btn);

        pending = {
          form,
          btn,
          meta
        };

        openModal(buildMessage(meta));
      },
      true
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attach);
  } else {
    attach();
  }
})();